module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"segmentSelection\">\n<p>Wählen Sie die Empfänger für Ihre Aussendung, indem Sie Segmente mit Adressen hinzufügen.</p>\n<div>\n<select name=\"segments\">\n<%\nvar assignedSegmentID, mailingSegmentID, j, i, s, currentMailingListID = 0, showSegment, segmentsDisplayed = false;\nfor (i in model.availableSegments) {\ns = (model.availableSegments[i] || {}).attributes || {};\nshowSegment = true;\nfor (j in model.assignedMailingSegments) {\nassignedSegmentID = j;\nmailingSegmentID = model.assignedMailingSegments[j];\n// this segment has been assigned already\nif (assignedSegmentID == s.segmentID) {\nshowSegment = false;\n}\n}\n// is segment assigned already, dont make it selectable here\nif (showSegment) {\nsegmentsDisplayed = true;\n// different mailing-list\nif (currentMailingListID != s.mailingListID) {\nif (currentMailingListID != 0) {\n%>\t\t\t\t\t\t\t</optgroup>\n<%\t\t\t\t\t\t}\n%>\t\t\t\t\t\t<optgroup label=\"<%= 'Mailingliste \"' + s.mailingListName + '\"' %>\" data-mailing-list-id=\"<%= s.mailingListID %>\">\n<%\t\t\t\t\t\tcurrentMailingListID = s.mailingListID;\n}\n%>\t\t\t\t\t<option value=\"<%- s.segmentID %>\">Segment \"<%- s.segmentName %>\"&nbsp;&nbsp;:::&nbsp;&nbsp;<%- s.subscriberCount || 'keine' %> Adressen</option>\n<%\t\t\t\t}\n}\nif (!segmentsDisplayed) {\n%>\t\t\t\t<option value=\"-\">Alle verfügbaren Segmente wurden zugewiesen!</option>\n<%\t\t\t}\nif (segmentsDisplayed) {\n%>\t\t\t\t</optgroup>\n<%\t\t\t}\n%>\t\t\t</select>\n<button type=\"button\" class=\"addSelectedSegment\"><i class=\"fi fi-segment\"></i> Segment hinzufügen</button>\n<button type=\"button\" class=\"importForMailing\"><i class=\"fi fi-download\"></i> IMPORT</button>\n<div class=\"assignedRecipientsCount\">\n<div class=\"title\">Empfänger gesamt:</div>\n<div class=\"count\"><%= model.statsRecipients > 0 ? model.statsRecipients : '-' %></div>\n<div><i class=\"fi fi-refresh\"></i></div>\n</div>\n</div>\n</div>\n<div class=\"assignedMailingSegments\">\n<div class=\"mailingSegment importedForMailing hidden\">\n<div>\n<div class=\"title\">Segment</div>\n<div class=\"segmentName\">Import für Aussendung</div>\n<div class=\"title\">Mailingliste&nbsp;&nbsp;/&nbsp;&nbsp;Empfänger</div>\n<div class=\"mailinglistName\">-</div>\n<div class=\"title\">Empfänger Gesamt</div>\n<div class=\"subscriptionCount\">\n<span>0</span>\n</div>\n<div class=\"removeMailingSegment\"><i class=\"fi fi-times\"></i> Segment entfernen</div>\n<div class=\"showEdit_mailingSubscribers\"><i class=\"fi fi-edit-slim\"></i> Empfänger bearbeiten</div>\n</div>\n</div>\n<%\nfor (i in model.availableSegments) {\ns = (model.availableSegments[i] || {}).attributes || {};\nfor (j in model.assignedMailingSegments) {\nassignedSegmentID = j;\nmailingSegmentID = model.assignedMailingSegments[j];\nlastSegmentUpdateTSFormatted = 'nie';\nif(s.subscriberCountTimeStamp != null){\nlastSegmentUpdateTSFormatted = utils.moment(s.subscriberCountTimeStamp).format('LLLL');\n}\n// this segment has been assigned already\nif (assignedSegmentID == s.segmentID) {\n%>\n<div class=\"mailingSegment\" data-mailing-segment-id=\"<%= mailingSegmentID %>\" data-segment-id=\"<%= s.segmentID %>\">\n<div>\n<div class=\"title\">Segment</div>\n<div class=\"segmentName\"><%= s.segmentName %></div>\n<div class=\"title\">Mailingliste</div>\n<div class=\"mailinglistName\"><%= s.mailingListName %></div>\n<div class=\"title\">Empfänger</div>\n<div class=\"subscriptionCount<%= s.subscriberCount>0  ? '' : ' no-recipients' %>\">\n<div class=\"lastSegmentUpdateTS\">Letzte Aktualisierung am: <%= lastSegmentUpdateTSFormatted %></div>\n<i class=\"fi fi-refresh\"></i>\n<span><%= s.subscriberCount || 'keine' %></span>\n</div>\n<div class=\"removeMailingSegment\"><i class=\"fi fi-times\"></i> Segment entfernen</div>\n</div>\n</div>\n<%\n}\n}\n} %>\n</div>\n</div>"
  , __filename = "components/templates/newsletter/mailings/edit/segments/segments.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"segmentSelection\">\n<p>Wählen Sie die Empfänger für Ihre Aussendung, indem Sie Segmente mit Adressen hinzufügen.</p>\n<div>\n<select name=\"segments\">\n")
    ; __line = 6
    ; 
var assignedSegmentID, mailingSegmentID, j, i, s, currentMailingListID = 0, showSegment, segmentsDisplayed = false;
for (i in model.availableSegments) {
s = (model.availableSegments[i] || {}).attributes || {};
showSegment = true;
for (j in model.assignedMailingSegments) {
assignedSegmentID = j;
mailingSegmentID = model.assignedMailingSegments[j];
// this segment has been assigned already
if (assignedSegmentID == s.segmentID) {
showSegment = false;
}
}
// is segment assigned already, dont make it selectable here
if (showSegment) {
segmentsDisplayed = true;
// different mailing-list
if (currentMailingListID != s.mailingListID) {
if (currentMailingListID != 0) {

    ; __line = 25
    ; __append("							</optgroup>\n")
    ; __line = 26
    ; 						}

    ; __line = 27
    ; __append("						<optgroup label=\"")
    ; __append(escapeFn( 'Mailingliste "' + s.mailingListName + '"' ))
    ; __append("\" data-mailing-list-id=\"")
    ; __append(escapeFn( s.mailingListID ))
    ; __append("\">\n")
    ; __line = 28
    ; 						currentMailingListID = s.mailingListID;
}

    ; __line = 30
    ; __append("					<option value=\"")
    ; __append( s.segmentID )
    ; __append("\">Segment \"")
    ; __append( s.segmentName )
    ; __append("\"&nbsp;&nbsp;:::&nbsp;&nbsp;")
    ; __append( s.subscriberCount || 'keine' )
    ; __append(" Adressen</option>\n")
    ; __line = 31
    ; 				}
}
if (!segmentsDisplayed) {

    ; __line = 34
    ; __append("				<option value=\"-\">Alle verfügbaren Segmente wurden zugewiesen!</option>\n")
    ; __line = 35
    ; 			}
if (segmentsDisplayed) {

    ; __line = 37
    ; __append("				</optgroup>\n")
    ; __line = 38
    ; 			}

    ; __line = 39
    ; __append("			</select>\n<button type=\"button\" class=\"addSelectedSegment\"><i class=\"fi fi-segment\"></i> Segment hinzufügen</button>\n<button type=\"button\" class=\"importForMailing\"><i class=\"fi fi-download\"></i> IMPORT</button>\n<div class=\"assignedRecipientsCount\">\n<div class=\"title\">Empfänger gesamt:</div>\n<div class=\"count\">")
    ; __line = 44
    ; __append(escapeFn( model.statsRecipients > 0 ? model.statsRecipients : '-' ))
    ; __append("</div>\n<div><i class=\"fi fi-refresh\"></i></div>\n</div>\n</div>\n</div>\n<div class=\"assignedMailingSegments\">\n<div class=\"mailingSegment importedForMailing hidden\">\n<div>\n<div class=\"title\">Segment</div>\n<div class=\"segmentName\">Import für Aussendung</div>\n<div class=\"title\">Mailingliste&nbsp;&nbsp;/&nbsp;&nbsp;Empfänger</div>\n<div class=\"mailinglistName\">-</div>\n<div class=\"title\">Empfänger Gesamt</div>\n<div class=\"subscriptionCount\">\n<span>0</span>\n</div>\n<div class=\"removeMailingSegment\"><i class=\"fi fi-times\"></i> Segment entfernen</div>\n<div class=\"showEdit_mailingSubscribers\"><i class=\"fi fi-edit-slim\"></i> Empfänger bearbeiten</div>\n</div>\n</div>\n")
    ; __line = 64
    ; 
for (i in model.availableSegments) {
s = (model.availableSegments[i] || {}).attributes || {};
for (j in model.assignedMailingSegments) {
assignedSegmentID = j;
mailingSegmentID = model.assignedMailingSegments[j];
lastSegmentUpdateTSFormatted = 'nie';
if(s.subscriberCountTimeStamp != null){
lastSegmentUpdateTSFormatted = utils.moment(s.subscriberCountTimeStamp).format('LLLL');
}
// this segment has been assigned already
if (assignedSegmentID == s.segmentID) {

    ; __line = 76
    ; __append("\n<div class=\"mailingSegment\" data-mailing-segment-id=\"")
    ; __line = 77
    ; __append(escapeFn( mailingSegmentID ))
    ; __append("\" data-segment-id=\"")
    ; __append(escapeFn( s.segmentID ))
    ; __append("\">\n<div>\n<div class=\"title\">Segment</div>\n<div class=\"segmentName\">")
    ; __line = 80
    ; __append(escapeFn( s.segmentName ))
    ; __append("</div>\n<div class=\"title\">Mailingliste</div>\n<div class=\"mailinglistName\">")
    ; __line = 82
    ; __append(escapeFn( s.mailingListName ))
    ; __append("</div>\n<div class=\"title\">Empfänger</div>\n<div class=\"subscriptionCount")
    ; __line = 84
    ; __append(escapeFn( s.subscriberCount>0  ? '' : ' no-recipients' ))
    ; __append("\">\n<div class=\"lastSegmentUpdateTS\">Letzte Aktualisierung am: ")
    ; __line = 85
    ; __append(escapeFn( lastSegmentUpdateTSFormatted ))
    ; __append("</div>\n<i class=\"fi fi-refresh\"></i>\n<span>")
    ; __line = 87
    ; __append(escapeFn( s.subscriberCount || 'keine' ))
    ; __append("</span>\n</div>\n<div class=\"removeMailingSegment\"><i class=\"fi fi-times\"></i> Segment entfernen</div>\n</div>\n</div>\n")
    ; __line = 92
    ; 
}
}
} 
    ; __line = 95
    ; __append("\n</div>\n</div>")
    ; __line = 97
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/mailings/edit/segments/segments.ejs

}